export default "__VITE_ASSET__N$3vJTLO__"